import TheGrid from '@/views/products/subsectors/grid'
import Edit from '@/views/products/subsectors/edit'

export default {
  path: '/products/subsectors',
  redirect: '/products/subsectors/index',
  name: 'subsectors',
  meta: {
    auth: {
      redirect: {
        name: 'subsectors.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'subsectors.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'subsectors.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'subsectors.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
